export default __webpack_public_path__ + "static/media/MX-Performance-Dual-Motor-Desktop.6c857d18.jpg";